import { IApplicationRolePermission } from "@interfaces/common.interfaces";
import { PPAPermissions } from "./permissions";


export const applicationRolePermissions: Array<IApplicationRolePermission> = [
    {
        title: "ppaRequests",
        sections: [
            {
                title: "ppaReportRequestsTitle",
                permissions: [
                    PPAPermissions.ViewAllReportRequests,
                    PPAPermissions.ViewMyReportRequests
                ]
            },
            {
                title: "ppaActionRequestsTitle",
                permissions: [
                    PPAPermissions.ViewAllActionRequests,
                    PPAPermissions.ViewMyActionRequests
                ]
            }
        ]
    },
    {
        title: "ppaGuestUsersReportGroupTitle",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewGuestUsersReportGroup
                ]
            },
            {
                title: "ppaGuestUserReportTitle",
                permissions: [
                    PPAPermissions.RequestGuestUserReport,
                    PPAPermissions.ViewAllGuestUserReports,
                    PPAPermissions.ViewMyGuestUserReports
                ]
            },
            {
                title: "ppaGuestUsersInTenantReportTitle",
                permissions: [
                    PPAPermissions.RequestGuestUsersInTenantReport,
                    PPAPermissions.ViewAllGuestUsersInTenantReports,
                    PPAPermissions.ViewMyGuestUsersInTenantReports
                ]
            },
            {
                title: "ppaGuestUsersInWorkspaceReportTitle",
                permissions: [
                    PPAPermissions.RequestGuestUsersInWorkspaceReportAny,
                    //PPAPermissions.RequestGuestUsersInWorkspaceReportMineOnly, // Not implemented yet
                    PPAPermissions.ViewAllGuestUsersInWorkspaceReports,
                    PPAPermissions.ViewMyGuestUsersInWorkspaceReports
                ]
            },
            {
                title: "ppaGuestUsersInWorkspacesByOwnerReportTitle",
                permissions: [
                    PPAPermissions.RequestGuestUsersInWorkspacesByOwnerReportAny,
                    PPAPermissions.RequestGuestUsersInWorkspacesByOwnerReportMineOnly,
                    PPAPermissions.ViewAllGuestUsersInWorkspacesByOwnerReports,
                    PPAPermissions.ViewMyGuestUsersInWorkspacesByOwnerReports
                ]
            }
        ]
    },
    {
        title: "ppaGuestUsersActionGroupTitle",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewGuestUsersActionGroup
                ]
            },
            {
                title: "ppaRemoveGuestUsersActionTitle",
                permissions: [
                    PPAPermissions.RequestRemoveGuestUsersAction,
                    PPAPermissions.ViewAllRemoveGuestUsersActions,
                    PPAPermissions.ViewMyRemoveGuestUsersActions
                ]
            }
        ]
    },
    {
        title: "ppaSharingLinksReportGroupTitle",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewSharingLinksReportGroup
                ]
            },
            {
                title: "ppaSharingLinksInTenantReportTitle",
                permissions: [
                    PPAPermissions.RequestSharingLinksInTenantReport,
                    PPAPermissions.ViewAllSharingLinksInTenantReports,
                    PPAPermissions.ViewMySharingLinksInTenantReports
                ]
            },
            {
                title: "ppaSharingLinksInWorkspaceReportTitle",
                permissions: [
                    PPAPermissions.RequestSharingLinksInWorkspaceReportAny,
                    //PPAPermissions.RequestSharingLinksInWorkspaceReportMineOnly, // Not implemented yet
                    PPAPermissions.ViewAllSharingLinksInWorkspaceReports,
                    PPAPermissions.ViewMySharingLinksInWorkspaceReports
                ]
            },
            {
                title: "ppaSharingLinksInWorkspacesByOwnerReportTitle",
                permissions: [
                    PPAPermissions.RequestSharingLinksInWorkspacesByOwnerReportAny,
                    PPAPermissions.RequestSharingLinksInWorkspacesByOwnerReportMineOnly,
                    PPAPermissions.ViewAllSharingLinksInWorkspacesByOwnerReports,
                    PPAPermissions.ViewMySharingLinksInWorkspacesByOwnerReports
                ]
            },
            {
                title: "ppaSharingLinksInOneDriveReportTitle",
                permissions: [
                    PPAPermissions.RequestSharingLinksInOneDriveReportAny,
                    PPAPermissions.RequestSharingLinksInOneDriveReportMineOnly,
                    PPAPermissions.ViewAllSharingLinksInOneDriveReports,
                    PPAPermissions.ViewMySharingLinksInOneDriveReports
                ]
            }
        ]
    },
    {
        title: "ppaSharingLinksActionGroupTitle",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewSharingLinksActionGroup
                ]
            },
            {
                title: "ppaRemoveSharingLinksActionTitle",
                permissions: [
                    PPAPermissions.RequestRemoveSharingLinksAction,
                    PPAPermissions.ViewAllRemoveSharingLinksActions,
                    PPAPermissions.ViewMyRemoveSharingLinksActions
                ]
            }
        ]
    },
    {
        title: "ppaStorageReportGroupTitle",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewStorageReportGroup
                ]
            },
            {
                title: "ppaStorageInTenantReportTitle",
                permissions: [
                    PPAPermissions.RequestStorageInTenantReport,
                    PPAPermissions.ViewAllStorageInTenantReports,
                    PPAPermissions.ViewMyStorageInTenantReports
                ]
            },
            {
                title: "ppaStorageInWorkspaceReportTitle",
                permissions: [
                    PPAPermissions.RequestStorageInWorkspaceReportAny,
                    //PPAPermissions.RequestStorageInWorkspaceReportMineOnly, // Not implemented yet
                    PPAPermissions.ViewAllStorageInWorkspaceReports,
                    PPAPermissions.ViewMyStorageInWorkspaceReports
                ]
            },
            {
                title: "ppaStorageInOneDriveReportTitle",
                permissions: [
                    PPAPermissions.RequestStorageInOneDriveReportAny,
                    PPAPermissions.RequestStorageInOneDriveReportMineOnly,
                    PPAPermissions.ViewAllStorageInOneDriveReports,
                    PPAPermissions.ViewMyStorageInOneDriveReports
                ]
            }
        ]
    },
    {
        title: "ppaOrphanedObjectsReportGroupTitle",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewOrphanedObjectsReportGroup
                ]
            },
            {
                title: "ppaOrphanedUsersInTenantReportTitle",
                permissions: [
                    PPAPermissions.RequestOrphanedUsersInTenantReport,
                    PPAPermissions.ViewAllOrphanedUsersInTenantReports,
                    PPAPermissions.ViewMyOrphanedUsersInTenantReports
                ]
            },
            {
                title: "ppaOrphanedMailboxesInTenantReportTitle",
                permissions: [
                    PPAPermissions.RequestOrphanedMailboxesInTenantReport,
                    PPAPermissions.ViewAllOrphanedMailboxesInTenantReports,
                    PPAPermissions.ViewMyOrphanedMailboxesInTenantReports
                ]
            },
            {
                title: "ppaOrphanedWorkspacesInTenantReportTitle",
                permissions: [
                    PPAPermissions.RequestOrphanedWorkspacesInTenantReport,
                    PPAPermissions.ViewAllOrphanedWorkspacesInTenantReports,
                    PPAPermissions.ViewMyOrphanedWorkspacesInTenantReports
                ]
            }
        ]
    },
    {
        title: "ppaUsageReportsGroupTitle",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewUsageReportsGroup
                ]
            },
            {
                title: "ppaInactiveWorkspacesInTenantReportTitle",
                permissions: [
                    PPAPermissions.RequestInactiveWorkspacesInTenantReport,
                    PPAPermissions.ViewAllInactiveWorkspacesInTenantReports,
                    PPAPermissions.ViewMyInactiveWorkspacesInTenantReports
                ]
            },
            {
                title: "ppaInactiveWorkspacesByOwnerReportTitle",
                permissions: [
                    PPAPermissions.RequestInactiveWorkspacesByOwnerReportAny,
                    PPAPermissions.RequestInactiveWorkspacesByOwnerReportMineOnly,
                    PPAPermissions.ViewAllInactiveWorkspacesByOwnerReports,
                    PPAPermissions.ViewMyInactiveWorkspacesByOwnerReports
                ]
            }
        ]
    },
    {
        title: "ppaSummaryReportsGroupTitle",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewSummaryReportsGroup
                ]
            },
            {
                title: "ppaWorkspaceSummaryInTenantReportTitle",
                permissions: [
                    PPAPermissions.RequestWorkspaceSummaryInTenantReport,
                    PPAPermissions.ViewAllWorkspaceSummaryInTenantReports,
                    PPAPermissions.ViewMyWorkspaceSummaryInTenantReports
                ]
            },
            {
                title: "ppaWorkspaceSummaryByOwnerReportTitle",
                permissions: [
                    PPAPermissions.RequestWorkspaceSummaryByOwnerReportAny,
                    PPAPermissions.RequestWorkspaceSummaryByOwnerReportMineOnly,
                    PPAPermissions.ViewAllWorkspaceSummaryByOwnerReports,
                    PPAPermissions.ViewMyWorkspaceSummaryByOwnerReports
                ]
            }
        ]
    },
    {
        title: "ppaFileSizeReportsGroupTitle",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewFileSizeReportsGroup
                ]
            },
            {
                title: "ppaFileSizeInTenantReportTitle",
                permissions: [
                    PPAPermissions.RequestFileSizeInTenantReport,
                    PPAPermissions.ViewAllFileSizeInTenantReports,
                    PPAPermissions.ViewMyFileSizeInTenantReports
                ]
            }
        ]
    },
    {
        title: "ppaOrphanedObjectsActionGroupTitle",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewOrphanedObjectsActionGroup
                ]
            },
            {
                title: "ppaRemoveOrphanedUsersActionTitle",
                permissions: [
                    PPAPermissions.RequestRemoveOrphanedUsersAction,
                    PPAPermissions.ViewAllRemoveOrphanedUsersActions,
                    PPAPermissions.ViewMyRemoveOrphanedUsersActions
                ]
            }
        ]
    },
    {
        title: "settings",
        sections: [
            {
                title: "general",
                permissions: [
                    PPAPermissions.ViewSettings,
                    PPAPermissions.ViewPermissionSettings
                ]
            }
        ]
    },
    {
        title: "permissions",
        sections: [
            {
                title: "ppaApplicationRolesTitle",
                permissions: [
                    PPAPermissions.ViewApplicationRoles,
                    PPAPermissions.AddApplicationRole,
                    PPAPermissions.UpdateApplicationRole,
                    PPAPermissions.DeleteApplicationRole,
                    PPAPermissions.UpdateApplicationRoleMembership,
                    //PPAPermissions.ViewApplicationRoleAssignments
                ]
            },
            {
                title: "ppaM365EntraIDPermissionsTitle",
                permissions: [
                    PPAPermissions.ViewMicrosoftEntraIDPermissions,
                    PPAPermissions.ConsentMicrosoftEntraIDPermissions
                ]
            }
        ]
    }
];